import { T_LANDING_PAGE_CONSTANTS } from './TYPES'

const FR_LANDING_PAGE_CONSTANTS: T_LANDING_PAGE_CONSTANTS = {
  PAGE_KICKER: 'Livre. Quiz. Communauté.',
  PAGE_TITLE: 'Une bibliothèque de quiz où la lecture rencontre le jeu.',
  PAGE_DESCRIPTION:
    'Les enfants lisent des livres hors ligne, puis répondent à de courts quiz qui évaluent leur compréhension de lecture. En chemin, ils gagnent des points, font grandir Griffy, leur griffon, et peuvent participer à des défis de lecture.',
  GET_STARTED_CTA_TEXT: 'Créer compte gratuitement',
  CARD_1_TITLE: 'Lis un livre',
  CARD_1_DESCRIPTION: 'Lis un livre, sans écran.',
  CARD_2_TITLE: 'Réponds au quiz',
  CARD_2_DESCRIPTION:
    'Développe ta compréhension de lecture et rejoins une communauté de lecteurs.',
  CARD_3_TITLE: 'Gagne des récompenses',
  CARD_3_DESCRIPTION: 'Gagne des points et des badges et fais grandir Griffy.',
  FEATURES_KICKER: "QU'EST-CE QUE GRIFFYREADS?",
  FEATURES_TITLE: 'Découvrez ses fonctionnalités.',
  FEATURES_CHILD_LABEL: 'POUR LES ENFANTS',
  FEATURES_ADULT_LABEL: 'POUR LES ADULTES',
  FEATURES_ENHANCE_READING_TITLE: [
    { label: 'Commence Ton' },
    {
      label: 'Parcours de',
      newLine: true
    },
    { label: 'Lecture', color: true }
  ],
  FEATURES_ENHANCE_READING_DESCRIPTION:
    "Lis des livres hors ligne et relève des défis passionnants dans divers genres ! La lecture quotidienne booste ton vocabulaire et tes compétences en communication, augmente ta créativité et renforce ton empathie, tout en rendant l'apprentissage amusant et gratifiant.",
  FEATURES_UNLOCK_AVATARS_TITLE: [
    { label: 'Réponds aux Quiz, Gagne des Points' },
    {
      label: '& développe ton Griffy',
      color: true
    }
  ],
  FEATURES_UNLOCK_AVATARS_DESCRIPTION:
    'Teste tes connaissances avec des quiz amusants et gagne des points pour chaque bonne réponse! Monte de niveau et observe ton Griffy devenir plus fort à mesure que tu te lances dans de nouvelles aventures.',
  FEATURES_CHALLENGE_FRIENDS_TITLE: [
    {
      label: 'Défie',
      color: true
    },
    {
      label: 'tes Amis'
    }
  ],
  FEATURES_CHALLENGE_FRIENDS_DESCRIPTION:
    'Relève des défis de lecture et vois qui peut gagner le plus de points. Que le meilleur lecteur gagne!',
  FEATURES_EARN_BADGES_TITLE: [
    { label: 'Gagne' },
    {
      label: 'des Badges',
      color: true
    }
  ],
  FEATURES_EARN_BADGES_DESCRIPTION:
    'Gagne divers badges pour tes réalisations et ton progrès!',
  FEATURES_CREATE_COMPETITIONS_TITLE: [
    { label: 'Créez des' },
    {
      label: 'Compétitions',
      color: true
    },
    { label: 'de Lecture Engagantes', newLine: true }
  ],
  FEATURES_CREATE_COMPETITIONS_DESCRIPTION:
    'Encouragez la lecture en créant des compétitions passionnantes pour vos enfants ou votre communauté. Motivez les jeunes lecteurs à participer à des défis amusants et éducatifs!',
  FEATURES_MANAGE_AND_TRACK_TITLE: [
    { label: 'Gérez et Suivez', color: true },
    {
      label: ' Facilement la Lecture des Enfants'
    }
  ],
  FEATURES_MANAGE_AND_TRACK_DESCRIPTION:
    "Gérer la lecture des enfants et organiser des concours est un jeu d'enfant. Surveillez facilement les progrès, les réalisations et les défis de chaque enfant!",
  FEATURES_CONTRIBUTE_TITLE: [
    { label: 'Ajoutez des Quiz', color: true },
    {
      label: ' et Faites Croître',
      newLine: true
    },
    { label: 'la Plateforme' }
  ],
  FEATURES_CONTRIBUTE_DESCRIPTION:
    "Ajoutez vos propres quiz pour aider à étendre notre bibliothèque de contenus éducatifs. Vos contributions améliorent directement l'expérience d'apprentissage des jeunes lecteurs!",

  HIGHLIGHT_TITLE: 'Sûr et fait pour les enfants',
  HIGHLIGHT_DESCRIPTION:
    "Un espace adapté aux enfants où l'apprentissage rencontre le plaisir. Les parents peuvent se détendre en sachant que leurs enfants sont dans un environnement sûr.",
  DOWNLOAD_TITLE: "Qu'attendez-vous?",
  DOWNLOAD_DESCRIPTION:
    "Le monde magique de GriffyReads n'est qu'à un clic ! Inscrivez-vous dès maintenant et embarquez vos enfants dans une aventure passionnante de lecture. Faites grandir leur Griffy, aidez-les à gagner des points et à devenir de véritables champions de la lecture !"
}

export default FR_LANDING_PAGE_CONSTANTS
